import { render, staticRenderFns } from "./DoorView.vue?vue&type=template&id=aebb0278"
import script from "./DoorView.vue?vue&type=script&lang=js"
export * from "./DoorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports